import React from "react";

import { BasketItem as BasketItemType } from "@is/types";

import BasketItemTemplate from "../BasketItemTemplate";
import CheckoutBasketItemTemplate from "../CheckoutBasketItemTemplate";
import useManageBasketItem from "./hooks/useManageBasketItem";

type Props = {
  item: BasketItemType;
  isCheckout?: boolean;
  onChangeQuantity: (itemId: string, newQuantity: number) => void;
  onRemove: (itemId: string) => void;
  onClick: (item: BasketItemType) => void;
};

const BasketItem = ({
  item,
  isCheckout,
  onChangeQuantity,
  onRemove,
  onClick,
}: Props) => {
  const {
    handleIncreaseQuantity,
    handleDecreaseQuantity,
    isLimitationWarningShown,
    warningText,
    handleClick,
  } = useManageBasketItem({ item, onChangeQuantity, onRemove, onClick });

  return (
    <>
      {!isCheckout ? (
        <BasketItemTemplate
          item={item}
          onClick={handleClick}
          isLimitationWarningShown={isLimitationWarningShown}
          warningText={warningText}
          onDecreaseQuantity={handleDecreaseQuantity}
          onIncreaseQuantity={handleIncreaseQuantity}
        />
      ) : (
        <CheckoutBasketItemTemplate item={item} onClick={handleClick} />
      )}
    </>
  );
};

export default BasketItem;
